import { Helmet } from "react-helmet-async"
import { observer } from "mobx-react-lite"
import { ScheduleEdit } from "../../features/schedule"

// ----------------------------------------------------------------------

export const ScheduleEditPage = observer(function ScheduleEditPage() {
  return (
    <>
      <Helmet>
        <title>Расписание - админ. панель</title>
      </Helmet>

      <ScheduleEdit/>
    </>
  )
})
